import { useCallback } from 'react'

import useWebinarAppState from '../../Webinar/providers/WebinarAppStateProvider'

import useSimplePubSubMessage from './useSimplePubSubMessage'

export default function useWebinarPublicChannel<T>(
  channel: string,
  onMessage?: (message: T) => void
) {
  const { publicChannelURL } = useWebinarAppState()

  if (publicChannelURL === null) {
    throw new Error(
      'useWebinarPublicChannel must be used after setting publicChannelURL'
    )
  }

  const channelWithSlash = !channel.startsWith('/') ? `/${channel}` : channel
  const channelAppended = `${publicChannelURL}${channelWithSlash}`

  const handleMessage = useCallback(
    (message: string) => {
      onMessage!(JSON.parse(message))
    },
    [onMessage]
  )

  return useSimplePubSubMessage<string>(
    channelAppended,
    onMessage !== undefined ? handleMessage : undefined
  )
}
